import React from 'react';
import { Navigate } from 'react-router-dom';
import { useHasRole } from '../hooks/useHasRole';
import LoadingSpinner from './Popup/LoadingSpinner';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { hasRole, isLoading } = useHasRole(requiredRole);

  // Show loading spinner while role checking is in progress
  if (isLoading) {
    return <LoadingSpinner message="Checking permissions..." />;
  }

  // Redirect to 403 if user lacks the required role
  if (!hasRole && !isLoading) {
    return <Navigate to="/403" replace />;
  }

  // Render children if user has the required role
  return children;
};

export default ProtectedRoute;